import { createSlice } from "@reduxjs/toolkit";
import { getPropertiesEntry } from "../requests";
import SaveWebView from "../requests/saveWebViev";
import { FetchMultiUrlData } from "../requests/multiUrl";
import { getGeneratorConfigs } from "../../hooks/helpersThirdStep";
import { vcardTypes } from "../../constants/common";

const initialState = {
  valueLink: ["", ""],
  valueStoreAppleGoogle: ["", "", "", ""],
  valueVCard: [
    "",
    "",
    [{ type: 0, value: "" }],
    [""],
    "",
    "",
    "",
    [""],
    "",
    "#ffffff",
    false,
    "",
  ],
  valueEmail: ["", "", "", ""],
  valueWhatsApp: ["", "", ""],
  saveWebViewValue: null,
  valueCrypto: ["", "", "", ""],
  valueText: [""],
  valueLinkList: {
    colors: ["#2F6BFD", "#0E379A", "#FFFFFF"],
    qrTitle: "",
    title: "",
    description: "",
    logo: "",
    links: [],
    socials: [],
    isLogoRound: true,
  },
  valueMultiUrl: ["", 0],
  valueMap: ["", "", "", ""],
  valueNameQr: "",
  valuePhone: [""],
  valueSms: ["", ""],
  firstPageSearchValue: "",
  generatorEditConfigs: null,
  generatorLanding: {
    vcardType: vcardTypes.file,
    vcardValue: [],
  },
};

const saveValue = createSlice({
  name: "saveValue",
  initialState,
  reducers: {
    resetSaveValue() {
      return initialState;
    },
    saveValueLink(state, { payload }) {
      state.valueLink = payload;
    },
    saveStoreAppleGoogle(state, { payload }) {
      state.valueStoreAppleGoogle = payload;
    },
    saveVCard(state, { payload }) {
      state.valueVCard = payload;
    },
    saveEmail(state, { payload }) {
      state.valueEmail = payload;
    },
    saveWhatsApp(state, { payload }) {
      state.valueWhatsApp = payload;
    },
    saveCrypto(state, { payload }) {
      state.valueCrypto = payload;
    },
    saveValueText(state, { payload }) {
      state.valueText = payload;
    },
    saveValueLinkList(state, { payload }) {
      state.valueLinkList = payload;
    },
    saveValueMultiUrl(state, { payload }) {
      state.valueMultiUrl = payload;
    },
    saveValueMap(state, { payload }) {
      state.valueMap = payload;
    },
    saveValueNameQr(state, { payload }) {
      state.valueNameQr = payload;
    },
    saveValuePhone(state, { payload }) {
      state.valuePhone = payload;
    },
    saveValueSms(state, { payload }) {
      state.valueSms = payload;
    },
    setFirstPageSearchValue(state, { payload }) {
      state.firstPageSearchValue = payload;
    },
    setGeneratorEditConfigs(state, { payload }) {
      state.generatorEditConfigs = payload;
    },
    setGeneratorLandingVcardType(state, { payload }) {
      state.generatorLanding.vcardType = payload;
    },
    setGeneratorLandingVcardValue(state, { payload }) {
      state.generatorLanding.vcardValue = payload;
    },
  },
  extraReducers: {
    [SaveWebView.fulfilled]: (state, { payload }) => {
      state.saveWebViewValue = payload;
    },
    [FetchMultiUrlData.fulfilled]: (state, { payload }) => {
      state.valueMultiUrl[1] = payload.type;
    },
    [getPropertiesEntry.fulfilled]: (state, { payload }) => {
      state.valueNameQr = payload.qrTitle;

      const { data, ...rest } = payload;
      const qrFrames = data?.qrFrames
        ? {
            ...data.qrFrames,
            ...(rest.frameTransform && { frameTransform: rest.frameTransform }),
            ...(rest.transformFrameText && {
              transformFrameText: rest.transformFrameText,
            }),
          }
        : undefined;
      const modifiedData = {
        ...data,
        ...(qrFrames ? { qrFrames } : {}),
      };
      state.generatorEditConfigs = getGeneratorConfigs(modifiedData);
    },
  },
});
export const {
  saveValueLink,
  saveStoreAppleGoogle,
  saveVCard,
  saveEmail,
  saveWhatsApp,
  saveCrypto,
  resetSaveValue,
  saveValueText,
  saveValueLinkList,
  saveValueMultiUrl,
  saveValueMap,
  saveValueNameQr,
  saveValuePhone,
  saveValueSms,
  setFirstPageSearchValue,
  setGeneratorEditConfigs,
  setGeneratorLandingVcardType,
  setGeneratorLandingVcardValue,
} = saveValue.actions;
export default saveValue.reducer;
